<template>
  <v-data-table
    :headers="headers"
    :items="rows"
    :items-per-page="readonly ? -1 : 30"
    :loading="loading"
    :hide-default-footer="readonly"
    :search="searchQuery"
    class="px-6 elevation-1"
  >
    <template v-if="!readonly" v-slot:top>
      <SearchTools :searchQuery.sync="searchQuery" hideActions />
    </template>
    <template v-slot:[`item.date`]="{ item }">
      {{ item.date | formatDate }}
    </template>
    <template v-slot:[`item.serviceExpenses`]="{ item }">
      {{ item.serviceExpenses.length > 0 ? "Да" : "Не" }}
    </template>
    <template v-if="!readonly" v-slot:[`item.actions`]="{ item }">
      <router-link
        v-if="!item.serviceVisitId && checkIfUserHasPermission(['service-update'])"
        :to="{
          name: 'edit-service-machine-rows',
          params: { machineId: item.machineId, id: item.id },
          query: $route.query
        }"
      >
        <v-btn class="mr-2" fab dark x-small><v-icon dark>mdi-pencil</v-icon></v-btn>
      </router-link>
    </template>
  </v-data-table>
</template>

<script>
import { permissionMixin } from "@/core/mixins/permissionMixin.js";
import SearchTools from "@/core/components/table/SearchTools.vue";

export default {
  name: "ServiceMachineRowsTable",
  mixins: [permissionMixin],
  components: { SearchTools },
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return {
      searchQuery: "",
      headers: [
        { text: this.$i18n.t("FORM_LABELS.DATE"), value: "date" },
        { text: this.$i18n.t("FORM_LABELS.SERVICE_TYPE"), value: "serviceType.name" },
        { text: this.$i18n.t("FORM_LABELS.PERIOD_VALUE"), value: "mileage" },
        { text: this.$i18n.t("FORM_LABELS.DESCRIPTION"), value: "description" },
        { text: this.$i18n.t("FORM_LABELS.EXPENSES"), value: "serviceExpenses" },
        { align: "right", text: this.$i18n.t("MENU.ITEM.ACTIONS"), value: "actions", sortable: false, width: "10%" }
      ]
    };
  }
};
</script>
